import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import Footer from './components/Footer';
import LoadingOverlay from './components/LoadingOverlay';
import Navbar from './components/Navbar';
import { useAuthUser } from './misc/lib/user';
import routes from './misc/routes';
import AboutPage from './pages/AboutPage';
import AdminPage from './pages/AdminPage';
import EditNewsPage from './pages/AdminPage/EditNewsPage';
import UploadNewsPage from './pages/AdminPage/UploadNewsPage';
import ContactPage from './pages/ContactPage';
import DocumentsPage from './pages/DocumentsPage';
import GalleryPage from './pages/GalleryPage';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import NewsPage from './pages/NewsPage';
import SpecificNewsPage from './pages/NewsPage/SpecificNewsPage';

function App() {
  const [ user, loading ] = useAuthUser();

  return loading ? <LoadingOverlay /> : (
    <BrowserRouter>
      <div className="main-content" style={ {
        minHeight: '100vh'
      } }>
        <Navbar />
        <Switch>
          <Route exact path={ routes.home.path } component={ HomePage } />

          <Route path={ routes.about.path } component={ AboutPage } />

          <Route exact path={ routes.documents.path } component={ DocumentsPage } />

          <Route path={ routes.news.path }>
            <Switch>
              <Route exact path={ routes.news.path } component={ NewsPage } />
              <Route exact path={ routes.news.children.specificNews.path }
                component={ SpecificNewsPage } />
            </Switch>
          </Route>

          <Route exact path={ routes.gallery.path } component={ GalleryPage } />

          <Route exact path={ routes.contact.path } component={ ContactPage } />

          <Route exact path={ routes.login.path }>
            { !user ? <LoginPage /> : <Redirect to={ routes.admin.path } /> }
          </Route>

          <Route path={ routes.admin.path }>
            { !user || !user.admin ? <Redirect to={ routes.home.path } /> : (
              <Switch>
                <Route exact path={ routes.admin.path } component={ AdminPage } />
                <Route exact path={ routes.admin.children.uploadNews.path }
                  component={ UploadNewsPage } />
                <Route exact path={ routes.admin.children.editNews.path }
                  component={ EditNewsPage } />
              </Switch>
            ) }
          </Route>
        </Switch>
      </div>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
